import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";

import { Observable } from "rxjs";

import { CAH } from "@models";
import { ActionService } from "@services";

export const authInterceptorFn: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const session = inject(ActionService).sR$();

  return next(session && req.context.get(CAH) ? req.clone({ headers: req.headers.set("Authorization", `Bearer ${session.token}`) }) : req);
};
